import { render, staticRenderFns } from "./ExchangeCode.vue?vue&type=template&id=3d8f497a&scoped=true"
import script from "./ExchangeCode.vue?vue&type=script&lang=js"
export * from "./ExchangeCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f497a",
  null
  
)

export default component.exports